import { render, staticRenderFns } from "./InternetRegistrationTable.vue?vue&type=template&id=0c52b5c9&scoped=true"
import script from "./InternetRegistrationTable.vue?vue&type=script&lang=js"
export * from "./InternetRegistrationTable.vue?vue&type=script&lang=js"
import style0 from "./InternetRegistrationTable.vue?vue&type=style&index=0&id=0c52b5c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c52b5c9",
  null
  
)

export default component.exports